export const API_ROOT = "/api/v1"

export default {
  API_ROOT
}

